import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import { useLabel } from "@/core/context/LabelsContext"
import { EventsCalendarQueryParams } from "@/organization/occurrence/OrganizationOccurrenceList"
import ProductFilterDropdown from "@components/dropdown/product/ProductFilterDropdown"
import { ProductFilterDropdownContentState } from "@components/dropdown/product/ProductFilterDropdownContent"
import { useQueryParamState } from "@disco-ui/tabs/DiscoQueryParamTabs"
import { useState } from "react"

function EventsProductsFilterDropdown() {
  const activeOrganization = useActiveOrganization()
  const [params, setParams] = useQueryParamState<EventsCalendarQueryParams>()
  const experienceLabel = useLabel("experience")
  const filteredProductIds = params.productIds ? params.productIds.split(",") : []
  const [filterState, setFilterState] = useState<ProductFilterDropdownContentState>({
    allProducts: { value: "all", title: "All" },
    products: [],
  })

  return (
    <ProductFilterDropdown
      testid={"EventFilter.products"}
      title={experienceLabel.singular}
      icon={"book"}
      hideCommunityOption
      multiSelect
      viewerIsMember={activeOrganization?.viewerIsOwnerOrAdmin ? undefined : true}
      filterByAdminAccess={false}
      filterState={filterState}
      setFilterState={setFilterState}
      onOptionSelect={(option) => {
        if (!option || !option.value || option.value === "all") {
          setParams({ productIds: undefined })
          return
        }

        if (filteredProductIds.includes(option.value)) {
          setParams({
            productIds: filteredProductIds.filter((id) => id !== option.value).join(","),
          })
          return
        }

        setParams({ productIds: [...filteredProductIds, option.value].join(",") })
      }}
    />
  )
}

export default EventsProductsFilterDropdown
